module.exports = __webpack_public_path__ + "img/ic_map_bus.3365dfd3.png";